import { render, staticRenderFns } from "./virtual-keyboard.vue?vue&type=template&id=7c838dab&scoped=true"
import script from "./virtual-keyboard.vue?vue&type=script&lang=js"
export * from "./virtual-keyboard.vue?vue&type=script&lang=js"
import style0 from "./virtual-keyboard.vue?vue&type=style&index=0&id=7c838dab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c838dab",
  null
  
)

export default component.exports